//----------------------------------------------Tables-----------------------------------//
let table = document.getElementsByTagName( 'TABLE' );
if (table) {
    for ( let i = table.length - 1; i >= 0; i-- ) {
        if ( !table[ i ].classList.contains( 'no-cover' ) ) {
            let cover = document.createElement( 'div' );
            cover.classList.add( 'cover-table' );
            table[ i ].parentNode.insertBefore( cover, table[ i ] );
            cover.appendChild( table[ i ] );
        }
    }
}